import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

import { PaginationPropType } from './types';

const Pagination = ({ page, pagination, onPageChange }) =>
  pagination &&
  !!pagination.total && (
    <ReactPaginate
      forcePage={page - 1}
      pageRangeDisplayed={2}
      marginPagesDisplayed={1}
      onPageChange={onPageChange}
      pageCount={
        pagination && pagination.limit
          ? Math.ceil(pagination.total / pagination.limit)
          : 1
      }
      containerClassName="pagination justify-content-center"
      activeClassName="active"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      previousLabel={
        <i
          className="fas fa-chevron-left"
          style={{
            paddingRight: '2px',
            paddingBottom: '2px',
          }}
        />
      }
      nextLabel={
        <i
          className="fas fa-chevron-right"
          style={{
            paddingLeft: '2px',
            paddingBottom: '2px',
          }}
        />
      }
      breakLabel="..."
    />
  );

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pagination: PaginationPropType,
  onPageChange: PropTypes.func.isRequired,
};

Pagination.defaultProps = {
  pagination: null,
};

export default Pagination;
